/**
 * NodePanelIllustration.tsx — illustrasjon på blå gradient-flate (4:3)
 *
 * Kodevindu til venstre og server-rack til høyre på en lys flate. Brukes ved
 * siden av funksjonsakkordionen og de nummererte stegene. Faste farger (egen
 * blå bakgrunn, ikke tema).
 */

import { useId } from 'react';
import { Rack } from '@/components/invps/parts';
import { Box } from '@/components/product/iso';
import styles from '@/components/product/illustrations.module.css';
import { CodeWindow } from './parts';

const S = 34;
const OX = 307;
const OY = 150;
const project = (x: number, y: number, z = 0) =>
  `${(OX + (x - y) * 0.866 * S).toFixed(1)},${(OY + (x + y) * 0.5 * S - z * S).toFixed(1)}`;

const TILE: [string, string, string] = ['#ffffff', '#d0e2ff', '#a6c8ff'];

export default function NodePanelIllustration({ label }: { label: string }) {
  const uid = useId();
  const bg = `${uid}-bg`;

  return (
    <svg className={styles.cubesFrame} viewBox="0 0 672 504" role="img" aria-label={label}>
      <defs>
        <linearGradient id={bg} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#d0e2ff" />
          <stop offset="1" stopColor="#4589ff" />
        </linearGradient>
      </defs>
      <rect width="672" height="504" fill={`url(#${bg})`} />
      <g transform="translate(0 50)">
        <Box x={0} y={0} z={0} w={8} d={5.4} h={0.3} colors={TILE} project={project} />
        <CodeWindow x={0.5} y={1.3} z={0.3} project={project} />
        <Rack x={5} y={1.4} z={0.3} units={3} project={project} />
      </g>
    </svg>
  );
}
